module.exports = __webpack_public_path__ + "resource/img/search.c8c19fad.png";